module.exports = __webpack_public_path__ + "static/media/69-iveco.623d85b4.jpg";